/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { createNamespacedWetagHooksForOrg, createWetagHooksForPropDriven } from '@frontend/wetags';
import type { MessagingInboxTags } from './tags';

const MESSAGING_INBOX_NAMESPACE = 'messaging-inbox';

export const MessagingInboxOrg = createNamespacedWetagHooksForOrg<MessagingInboxTags>(MESSAGING_INBOX_NAMESPACE);
export const MessagingInboxProp = createWetagHooksForPropDriven<MessagingInboxTags>(MESSAGING_INBOX_NAMESPACE);
